import { useSelector } from 'react-redux';
import getStatus from '../selectors/status';

const useStatus = (statusName) => {
  const allStatuses = useSelector(getStatus);
  return allStatuses[statusName];
};

export default useStatus;
